import Vue from 'vue';
import Router from 'vue-router';
import store from '@/config/store';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home/Home'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login'),
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: () => import(/* webpackChunkName: "permissions" */ '@/views/Permissions/Permissions'),
    },
  ],
});

export default router;
